import { type Dispatch, type SetStateAction } from 'react';
import { RadioGroup } from '@headlessui/react';
import { RadioOff, RadioOn } from '@hungryroot/icons';
import { Text } from '@hungryroot/ramen';
import { type CancelReason } from '@hungryroot/rest/api/get_cancel_reasons/get';
import style from './ControlRadioGroup.module.css';

interface Props {
  testid?: string;
  options: CancelReason[];
  value: CancelReason['id'] | null;
  onChange: Dispatch<SetStateAction<number | null>>;
}

export function ControlRadioGroup(props: Props) {
  const { testid, options, value, onChange } = props;

  return (
    <RadioGroup data-testid={testid} value={value} onChange={onChange}>
      {options.map((option) => {
        const { id: optionId } = option;
        return (
          <RadioGroup.Option
            data-testid={`${testid}-option-${optionId}`}
            value={optionId}
            key={optionId}
            className={style.option}
          >
            {({ checked }) => (
              <span className={checked ? style.on : style['off']}>
                {checked ? <RadioOn /> : <RadioOff />}

                <Text>{option.name}</Text>
              </span>
            )}
          </RadioGroup.Option>
        );
      })}
    </RadioGroup>
  );
}
